import { createRouter, createWebHistory } from 'vue-router'
import DashboardView from './views/DashboardView.vue'

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', component: DashboardView },
    { path: '/policies', component: DashboardView },
    { path: '/analysis', component: DashboardView },
    { path: '/ai', component: DashboardView },
    { path: '/backup', component: DashboardView },
    { path: '/settings', component: DashboardView },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
  scrollBehavior: () => ({ top: 0 }),
})
